import request from '@/utils/request'

// 上传文件到临时目录
export function uploadFile(file, path) {
    return request({
        url: '/sys/upload/file/temp/bucket',
        method: 'post',
        data: file,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}


/*======================================产品型号======================================*/
// 产品型号表-分页查询
export function productModelList(data) {
    return request({
        url: '/shop/product/model/page',
        method: 'post',
        data
    })
}

// 产品型号表-详情
export function productModelDetail(id) {
    return request({
        url: `/shop/product/model/${id}`,
        method: 'get'
    })
}

// 产品型号表-新增
export function productModelAdd(data) {
    return request({
        url: '/shop/product/model',
        method: 'post',
        data
    })
}

// 产品型号表-更新
export function productModelUpdate(data) {
    return request({    
        url: '/shop/product/model',
        method: 'put',
        data
    })
}

// 产品型号表-删除
export function productModelDelete(id) {
    return request({
        url: `/shop/product/model/${id}`,
        method: 'delete'
    })
}

/*======================================产品尺寸======================================*/
// 产品尺寸表-分页查询
export function productSizeList(data) {
    return request({
        url: '/shop/product/size/page',
        method: 'post',
        data
    })
}

// 产品尺寸表-详情
export function productSizeDetail(id) {
    return request({
        url: `/shop/product/size/${id}`,
        method: 'get'
    })
}

// 产品尺寸表-新增
export function productSizeAdd(data) {
    return request({
        url: '/shop/product/size',
        method: 'post',
        data
    })
}

// 产品尺寸表-更新
export function productSizeUpdate(data) {
    return request({    
        url: '/shop/product/size',
        method: 'put',
        data
    })
}

// 产品尺寸表-删除
export function productSizeDelete(id) {
    return request({
        url: `/shop/product/size/${id}`,
        method: 'delete'
    })
}

/*======================================配置分组======================================*/
// 配置分组-分页查询
export function configGroupList(data) {
    return request({
        url: '/shop/config/group/page',
        method: 'post',
        data
    })
}

// 配置分组-详情
export function configGroupDetail(id) {
    return request({
        url: `/shop/config/group/${id}`,
        method: 'get'
    })
}

// 配置分组-删除
export function configGroupDelete(id) {
    return request({
        url: `/shop/config/group/${id}`,
        method: 'delete'
    })
}

// 配置分组-更新
export function configGroupUpdate(data) {
    return request({
        url: '/shop/config/group',
        method: 'put',
        data
    })
}

// 配置分组-新增
export function configGroupAdd(data) {
    return request({
        url: '/shop/config/group',
        method: 'post',
        data
    })
}



/*======================================配置子项======================================*/
// 配置子项-分页查询
export function configItemList(data) {
    return request({
        url: '/shop/config/item/page',
        method: 'post',
        data
    })
}

// 配置子项-详情
export function configItemDetail(id) {
    return request({
        url: `/shop/config/item/${id}`,
        method: 'get'
    })
}

// 配置子项-新增
export function configItemAdd(data) {
    return request({
        url: '/shop/config/item',
        method: 'post',
        data
    })
}

// 配置子项-更新
export function configItemUpdate(data) {
    return request({
        url: '/shop/config/item',
        method: 'put',
        data
    })
}

// 配置子项-删除
export function configItemDelete(id) {
    return request({
        url: `/shop/config/item/${id}`,
        method: 'delete'
    })
}


/*======================================产品基准毛利======================================*/
//产品基准毛利-更新
export function productBaseMarginRateUpdate(data) {
    return request({    
        url: '/shop/product/model/margin/config',
        method: 'put',
        data
    })
}

//产品基准毛利-新增
export function productBaseMarginRateAdd(data) {
    return request({
        url: '/shop/product/model/margin/config',
        method: 'post',
        data
    })
}

//产品基准毛利-分页
export function productBaseMarginRateList(data) {
    return request({
        url: '/shop/product/model/margin/config/page',
        method: 'post',
        data
    })
}

//产品基准毛利-详情
export function productBaseMarginRateDetail(id) {
    return request({
        url: `/shop/product/model/margin/config/${id}`,
        method: 'get'
    })
}

//产品基准毛利-删除
export function productBaseMarginRateDelete(id) {
    return request({
        url: `/shop/product/model/margin/config/${id}`,
        method: 'delete'
    })
}

/*======================================产品参数分组======================================*/

// 产品参数分组-分页查询
export function productParamGroupList(data) {
    return request({
        url: '/shop/model/param/group/page',
        method: 'post',
        data
    })
}

// 产品参数分组-详情
export function productParamGroupDetail(id) {
    return request({
        url: `/shop/model/param/group/${id}`,
        method: 'get'
    })
}

// 产品参数分组-删除
export function productParamGroupDelete(id) {
    return request({
        url: `/shop/model/param/group/${id}`,
        method: 'delete'
    })
}

// 产品参数分组-更新
export function productParamGroupUpdate(data) {
    return request({    
        url: '/shop/model/param/group',
        method: 'put',
        data
    })
}

// 产品参数分组-新增
export function productParamGroupAdd(data) {
    return request({
        url: '/shop/model/param/group',
        method: 'post',
        data
    })
}

/*======================================产品参数子项======================================*/

// 产品参数子项-分页查询
export function productParamItemList(data) {
    return request({
        url: '/shop/model/param/item/page',
        method: 'post',
        data
    })
}

// 产品参数子项-详情
export function productParamItemDetail(id) {
    return request({
        url: `/shop/model/param/item/${id}`,
        method: 'get'
    })
}

// 产品参数子项-删除
export function productParamItemDelete(id) {
    return request({
        url: `/shop/model/param/item/${id}`,
        method: 'delete'
    })
}

// 产品参数子项-更新
export function productParamItemUpdate(data) {
    return request({    
        url: '/shop/model/param/item',
        method: 'put',
        data
    })
}

// 产品参数子项-新增
export function productParamItemAdd(data) {
    return request({
        url: '/shop/model/param/item',
        method: 'post',
        data
    })
}

/*======================================产品参数关联======================================*/

// 产品参数关联-分页查询
export function productParamRelList(data) {
    return request({
        url: '/shop/model/param/rel/page',
        method: 'post',
        data
    })
}
// 产品参数关联-详情
export function productParamRelDetail(id) {
    return request({
        url: `/shop/model/param/rel/${id}`,
        method: 'get'
    })
}
// 产品子项参数关联-删除
export function productParamRelDelete(id) {
    return request({
        url: `/shop/model/param/rel/${id}`,
        method: 'delete'
    })
}

// 产品分组参数关联-删除
export function productParamRelDeleteByModelIdAndGroupId(mid, gid) {
    return request({
        url: `/shop/model/param/rel/${mid}/${gid}`,
        method: 'delete'
    })
}

// 产品参数关联-更新
export function productParamRelUpdate(data) {
    return request({    
        url: '/shop/model/param/rel',
        method: 'put',
        data
    })
}
// 产品参数关联-新增
export function productParamRelAdd(data) {
    return request({
        url: '/shop/model/param/rel',
        method: 'post',
        data
    })
}

//根据产品型号id查询产品_参数_分组详情
export function productParamGroupModelDetail(id) {
    return request({
        url: `/shop/model/param/rel/model/${id}`,
        method: 'get'
    })
}






/*======================================产品型号运维费======================================*/
// 产品型号运维费
export const productModelOperationFeeApi = {
    // 分页查询
    page: (data) => request.post('/shop/product/model/operation/fee/page', data),
    // 详情
    detail: (id) => request.get(`/shop/product/model/operation/fee/${id}`),
    // 新增
    add: (data) => request.post('/shop/product/model/operation/fee', data),
    // 更新
    update: (data) => request.put('/shop/product/model/operation/fee', data),
    // 删除
    delete: (id) => request.delete(`/shop/product/model/operation/fee/${id}`),
}

// 模板产品尺寸
export const templateProductSizeApi = {
    // 分页查询
    page: (data) => request.post('/shop/template/product/size/page', data),
    // 详情
    detail: (id) => request.get(`/shop/template/product/size/${id}`),
    // 新增
    add: (data) => request.post('/shop/template/product/size', data),
    // 批量新增
    batchSave: (data) => request.post('/shop/template/product/size/batch/save', data),
    // 更新
    update: (data) => request.put('/shop/template/product/size', data),
    // 删除
    delete: (id) => request.delete(`/shop/template/product/size/${id}`),
}



/*======================================产品模板======================================*/

// 模板产品型号
export const templateProductModelApi = {
    // 分页查询
    page: (data) => request.post('/shop/template/product/model/page', data),
    // 详情
    detail: (id) => request.get(`/shop/template/product/model/${id}`),
    // 新增
    add: (data) => request.post('/shop/template/product/model', data),
    // 更新
    update: (data) => request.put('/shop/template/product/model', data),
    // 删除
    delete: (id) => request.delete(`/shop/template/product/model/${id}`),
}

// 模板产品分组可选
export const templateProductItemApi = {
    // 分页查询
    page: (data) => request.post('/shop/template/product/item/page', data),
    // 详情
    detail: (id) => request.get(`/shop/template/product/item/${id}`),
    // 新增
    add: (data) => request.post('/shop/template/product/item', data),
    // 批量新增
    batchSave: (data) => request.post('/shop/template/product/item/batch/save', data),
    // 更新
    update: (data) => request.put('/shop/template/product/item', data),
    // 删除
    delete: (id) => request.delete(`/shop/template/product/item/${id}`),
}
